import {useMatch} from '@github-ui/react-router'

const CommitsRoutePath = '/:owner/:repo/pull/:pr_number/commits'
const FilesRoutePath = '/:owner/:repo/pull/:pr_number/files'
const ChecksRoutePath = '/:owner/:repo/pull/:pr_number/checks'
const ChangesRoutePath = '/:owner/:repo/pull/:pr_number/changes'
const ChangesWithRangeRoutePath = '/:owner/:repo/pull/:pr_number/changes/:range'
const FindingsRoutePath = '/:owner/:repo/pull/:pr_number/findings'

/**
 * Returns the name of the current pull request tab based on the route,
 * or 'show' if on the conversation tab (default).
 */
export function useCurrentPullRequestTab(): string {
  const isFilesRoute = useMatch(`${FilesRoutePath}/*`) !== null
  const isCommitsRoute = useMatch(`${CommitsRoutePath}/*`) !== null
  const isChecksRoute = useMatch(`${ChecksRoutePath}/*`) !== null
  const isChangesRoute = useMatch(`${ChangesRoutePath}/*`) !== null
  const isChangesWithRangeRoute = useMatch(`${ChangesWithRangeRoutePath}/*`) !== null
  const isFindingsRoute = useMatch(`${FindingsRoutePath}/*`) !== null

  if (isFilesRoute || isChangesRoute || isChangesWithRangeRoute) return 'files'
  if (isCommitsRoute) return 'commits'
  if (isChecksRoute) return 'checks'
  if (isFindingsRoute) return 'findings'
  return 'show'
}
